module.exports = __webpack_public_path__ + "media/assets/icons/background-a66170ae5216117480be48cc7ec7c0ac.svg";